<nb-card class="card-sroll">
	<nb-card-header>
		<ngx-back-navigation class="float-left"></ngx-back-navigation>
		<nb-actions class="float-left pt-2" size="small">
			<nb-action class="toggle-layout p-0">
				<h5>{{ 'MENU.UPWORK' | translate }}</h5>
				<nb-icon
					icon="settings-2-outline"
					[nbContextMenu]="supportContextActions"
				></nb-icon>
			</nb-action>
		</nb-actions>
	</nb-card-header>
	<nb-card-body>
		<div>
			<nb-route-tabset [tabs]="tabs" fullWidth></nb-route-tabset>
		</div>
	</nb-card-body>
</nb-card>
